<kzn-dialog
  [title]="t('recallRequestTitle')"
  [actionLabel]="t('recallRequestConfirm')"
  [secondaryActionLabel]="t('cancel')"
  (actionFired)="onAction()"
  (secondaryActionFired)="onSecondaryAction()"
  [isActionDisabled]="isFormInvalid">
  <div class="content__recall-request">
    <span>{{ t('recallRequestBody') }}</span>
    <mat-form-field appearance="outline" class="input__recall-field">
      <mat-label>{{ t('recallReasonLabel') }}</mat-label>
      <textarea
        matInput
        rows="3"
        [placeholder]="t('recallReasonPlaceholder')"
        [formControl]="recallReason"></textarea>
      @if (recallReason.invalid && recallReason.touched) {
        <mat-error>{{ Messages.MSG_ERROR_REQUIRED }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="input__recall-field input__recall-field--readonly">
      <mat-label>{{ t('recalledByLabel') }}</mat-label>
      <input
        type="text"
        matInput
        readonly
        [formControl]="recalledBy" />
    </mat-form-field>
  </div>
</kzn-dialog>
